import styled from 'styled-components';

import List from 'components/list';

import theme from './theme';

export const SelectionContainer = styled.div`
  border-bottom: 1px solid ${Styles.color.grey.four};
  padding: 0.75rem 0;

  &:first-child {
    padding-top: 0;
  }
`;

export const Name = styled.div`
  font-weight: ${Styles.fontWeight.heavy};
  color: ${theme.nameColor};
  font-size: 1rem;
  margin-bottom: 5px;
  text-transform: uppercase;
  text-align: left;
`;

export const Description = styled.div`
  display: block;
  font-size: 0.87rem;
  font-weight: ${Styles.fontWeight.normal};
`;

export const ExpiryText = styled.div`
  margin-top: 8px;
  font-size: 0.87rem;
  font-weight: ${Styles.fontWeight.normal};
  color: ${theme.ExpiryText};
  margin-left: 30px; // aligns text to the label
`;

export const StyledList = styled(List)`
  width: 100%;
`;

export const NotFoundContainer = styled.div`
  display: flex;
  flex-flow: column wrap;
  justify-content: center;
  align-items: center;
`;

export const NotFoundName = styled.div`
  font-family: ${Styles.fontFamily.base};
  font-size: 1.5rem;
  text-transform: uppercase;
  padding-bottom: 0.8rem;
`;

export const NotFoundDescription = styled.div`
  font-size: 0.8rem;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row nowrap;
  align-items: center;
`;

export const ButtonContainer = styled.div`
  position: absolute;
  bottom: 0;
  border-top: 1px solid ${Styles.color.grey.four};
  width: 100%;
  height: 87px;
  display: flex;
  align-items: center;
  background: ${Styles.color.grey.five};

  ${Styles.mobileFullscreen`
    /* using the full safe-area inset makes this component too tall */
    padding-bottom: calc(env(safe-area-inset-bottom) / 2);
  `}
`;
